import axios from 'axios'
import { DESEMBARCAR_PASSAGEIRO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function desembarcarPassageiro (idEmpresa, idReserva) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/reserva/${idReserva}/desembarcar-passageiro`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: DESEMBARCAR_PASSAGEIRO,
        payload: response
      })
  );
}
